import {ChangeDetectionStrategy, Component, contentChild, contentChildren, Directive, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {TranslateModule} from "@ngx-translate/core";
import {finnNærmesteForelderElementSomMatcher} from "felles-ng2/støttefunksjoner/dom";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";

const debug = initDebugger('DokumentKomponent');


@Directive({selector: '[bakgrunn]', standalone: true})
export class DokumentBakgrunnDirektiv {
    tittel = input('');
}

@Directive({selector: '[handling]', standalone: true})
export class DokumentHandlingDirektiv {
}

@Directive({selector: '[filnavn]', standalone: true})
export class DokumentFilnavnDirektiv {
    // filnavn = input.required<string>();
}

@Directive({selector: '[metainformasjon]', standalone: true})
export class DokumentMetainformasjonDirektiv {
}

@Component({
    selector: 'dokument',
    templateUrl: 'dokument.html',
    styleUrl: 'dokument.scss',
    imports: [
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DokumentKomponent {

    bakgrunn = contentChild(DokumentBakgrunnDirektiv);
    handlinger = contentChildren(DokumentHandlingDirektiv);
    filnavn = contentChild(DokumentFilnavnDirektiv);
    metainformasjon = contentChild(DokumentMetainformasjonDirektiv);

    constructor() {
    }
}

/** Returnerer sann dersom angitt event stammer fra klikk på 'informasjon'-elementet i {@link DokumentKomponent} */
export function erKlikkPåDokumentInformasjonselement($event: PointerEvent): boolean {
    if (!($event.target instanceof HTMLElement)) return false;
    return (erIkkeNil(finnNærmesteForelderElementSomMatcher($event.target, kandidat => kandidat.dataset.informasjonelement === 'true')));
}
